// Common utilities functions shared by screenshot and web.
import html2canvas from "html2canvas";
import { IsPaidCycleValid, LogMessage } from "../helper-func";
import Constants from "../constants";
import { GetUserInfoInExtensionAsync } from "../user-info";
export function SaveHtmlElementToImage(root, size = null, originalPageSize = null) {
    LogMessage("save image");
    html2canvas(root, {
        allowTaint: true,
        useCORS: true,
        foreignObjectRendering: true,
    }).then((canvas) => {
        // Crop the canvas to remove the empty space in the right or bottom of image.
        let canvasUrl = "";
        if (size == null) {
            canvasUrl = canvas.toDataURL(Constants.DefaultImageMimeType, 0.99);
        }
        else {
            const scale = canvas.width / originalPageSize?.width;
            LogMessage(`crop image to ${size.width} ${size.height} from canvas ${canvas.width} ${canvas.height} scale: ${scale}`);
            const croppedCanvas = document.createElement('canvas');
            croppedCanvas.width = size.width;
            croppedCanvas.height = size.height;
            const croppedCtx = croppedCanvas.getContext('2d');
            croppedCtx?.drawImage(canvas, 0, 0, size.width * scale, size.height * scale, 0, 0, size.width, size.height);
            canvasUrl = croppedCanvas.toDataURL(Constants.DefaultImageMimeType, 0.99);
        }
        // Create an anchor, and set the href value to our data URL
        const createEl = document.createElement('a');
        createEl.href = canvasUrl;
        // This is the name of our downloaded file
        createEl.download = `screenshot.${Constants.DefaultImageFormat}`;
        // Click the download button, causing a download, and then remove it
        createEl.click();
        createEl.remove();
    });
}
export function ToggleDialogVisibility(dialog, show) {
    // flex seems conflict with hidden
    if (show) {
        dialog.classList.remove('hidden');
        dialog.classList.add('flex');
        document.body.style.overflow = 'hidden';
    }
    else {
        dialog.classList.add('hidden');
        dialog.classList.remove('flex');
        document.body.style.overflow = 'auto';
    }
}
function IsRegularLink(href) {
    if (href === undefined || href === null) {
        return false;
    }
    return !(href.startsWith('chrome') || href.startsWith('file://'));
}
export function SetLinkOrHide(link, href) {
    link.href = href;
    if (IsRegularLink(href)) {
        link.classList.remove('hidden');
    }
    else {
        link.classList.add('hidden');
    }
}
export async function IsPaidUser() {
    const userInfo = await GetUserInfoInExtensionAsync();
    if (userInfo == null) {
        return false;
    }
    return IsPaidCycleValid(userInfo.quotaEndTime);
}
